// extracted by mini-css-extract-plugin
export default {"successTick":"RequestSuccessModal_successTick__RGoly","modalWrapper":"RequestSuccessModal_modalWrapper__VzG1z"};